import axios from 'axios';
import { API_URL } from './service';

export interface Viewer {
  id: number;
  email: string;
  name: string;
  company_id: number;
}

//export const register = (username: string, email: string, password: string) => {
//  return axios.post(API_URL + "auth/signup", {
//    username,
//    email,
//    password,
//  });
//};

export const login = async (email: string, password: string) => {
  const { data } = await axios
    .post(API_URL + "auth/signin", { email: email, password: password });
  return data;
  /*
  return axios
    .post(API_URL + "auth/signin", { email: email, password: ciphertext })
    .then(res => {
      if (res.status === 200) { return res; }
      return null;
    }).catch((err: Error | AxiosError) => {
      if (axios.isAxiosError(err)) {
        // Access to config, request, and response
        if (err.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          //console.log(err.response.data);
          //console.log(err.response.status);
          //console.log(err.response.headers);
        } else if (err.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          //console.log(err.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          //console.log('Error', err.message);
        }
        //console.log(err.config);
      } else {
        // Just a stock error
      }
      return null;
    });
    */
};

export const requestPassword = async (email: string) => {
  const { data } = await axios.post(API_URL + "auth/password", {
    email: email
  });
  return data;
};


export const getCurrentViewer = async (token: string) => {
  const { data } = await axios.get(API_URL + "auth/profile", {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  return data;
};

export const setPassword = async (viewer: Viewer, password: string, token: string) => {
  const newViewer = {
    id: viewer.id,
    email: viewer.email,
    nome: viewer.name,
    empresa_id: viewer.company_id,
    password: password
  };

  const response = await axios.put(API_URL + "auth/viewer/" + viewer.id,
    { viewer: newViewer }, { headers: { 'Authorization': `Bearer ${token}` } });

  return response.status === 200;
};
